module.exports = __webpack_public_path__ + "img/1440.63bfc1c1.jpg";